import { useRef, useState } from "react"
import { useLocomotiveScroll } from "react-locomotive-scroll"
import { CiLocationOn, CiUser } from "react-icons/ci"
import { GiCheckMark } from "react-icons/gi"
import useMultipleForm from "../hooks/useMultipleForm"
import Billing from "./Billing"
import OrderSummary from "./OrderSummary"
import Payment from "./Payment"
import Shipping from "./Shipping"

const CheckoutForm = () => {
  const { scroll } = useLocomotiveScroll()
  const containerRef = useRef(null)
  const [billingFormData, setBillingFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    address: "",
    suite: "",
    city: "",
    country: "Ethiopia",
    state: "",
    zipCode: "",
  })
  const { currentNode, next, selectedIndex, get } = useMultipleForm([
    <Billing formData={billingFormData} setFormData={setBillingFormData} />,
    <Shipping />,
    <Payment />,
  ])

  const canSave = [
    billingFormData.fullName,
    billingFormData.email,
    billingFormData.address,
    billingFormData.city,
    billingFormData.zipCode,
  ].every(Boolean)

  const handleClick = (e) => {
    e.preventDefault()

    if (!canSave)
      return alert("Please fill in all the required fields before continuing")
    next()
    scroll.scrollTo(0, { duration: 0, disableLerp: true })
  }

  return (
    <section id="c-container" data-scroll-section className="checkout-form">
      <div ref={containerRef} className="checkout-form__grid wrapper-md">
        <div className="c-ptop checkout-form__flex">
          {currentNode}
          <div className="checkout-form__form checkout-form__form-btn">
            <button
              disabled={selectedIndex >= 2}
              onClick={(e) => handleClick(e)}
              className="btn-cta danger c-btn"
            >
              {selectedIndex === 0
                ? "Continue to shipping"
                : selectedIndex === 1
                ? "Continue to payment"
                : "Finalise payment"}
            </button>
          </div>
        </div>
        <div
          data-scroll
          data-scroll-sticky
          data-scroll-target="#c-container"
          className="c-ptop checkout-form__flex sticky"
        >
          {selectedIndex >= 1 ? (
            <div className="checkout-form__flex billing-filled">
              <div className="billing checkout-form__form">
                <div className="checkout-form-count checked">
                  <GiCheckMark />
                </div>
                <div className="checkout-form__form-header">
                  <h1 className="title-md">Billing</h1>
                  <button disabled={selectedIndex < 1} onClick={() => get(0)}>
                    edit
                  </button>
                </div>
                <div className="billing-filled-desc">
                  <div className="billing-filled-desc-grid">
                    <CiUser />
                    <div className="row">
                      <p>{billingFormData.fullName || ""}</p>
                      <p>{billingFormData.email || ""}</p>
                    </div>
                  </div>
                  <div className="billing-filled-desc-grid">
                    <CiLocationOn />
                    <div className="row">
                      <p>
                        {billingFormData.address || ""},{" "}
                        {billingFormData.city || ""},{" "}
                        {billingFormData.state || ""},{" "}
                        {billingFormData.suite || ""}
                      </p>
                      <p>{billingFormData.zipCode || ""}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {selectedIndex >= 2 ? (
            <div className="checkout-form__flex billing-filled">
              <div className="billing checkout-form__form">
                <div className="checkout-form-count checked">
                  <GiCheckMark />
                </div>
                <div className="checkout-form__form-header">
                  <h1 className="title-md">Shipping</h1>
                  <button disabled={selectedIndex < 2} onClick={() => get(1)}>
                    edit
                  </button>
                </div>
                <div className="billing-filled-desc-grid">
                  <CiLocationOn />
                  <div className="row">
                    <p>
                      {billingFormData.address || ""},{" "}
                      {billingFormData.city || ""},{" "}
                      {billingFormData.state || ""},{" "}
                      {billingFormData.suite || ""}
                    </p>
                    <p>{billingFormData.zipCode || ""}</p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <OrderSummary />
        </div>
      </div>
    </section>
  )
}

export default CheckoutForm
